import React from 'react'
import Sidebar from '../../../Components/Sidebar/Sidebar';
import { customerSideBarItems } from './Routes'

const Navbar = () => {
    return <Sidebar sideBarItems={customerSideBarItems} />
}

export default Navbar;